/// <amd-module name="VSS/Platform/RestClient/Settings" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   webplatform\web\extensions\vss-web\vss-platform\genclient.json
 */

import { IVssPageContext, IVssRestClientOptions, RestClients } from "../Context";
import { RestClientBase } from "../RestClientBase";

import { ISettingsRestClient } from "VSS/Platform/RestClient/Settings.Types";

export { ISettingsRestClient } from "VSS/Platform/RestClient/Settings.Types";

class SettingsRestClient extends RestClientBase implements ISettingsRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Get all setting entries for the given user/all-users scope
     * 
     * @param userScope - User-Scope at which to get the value. Should be "me" for the current user or "host" for all users.
     * @param key - Optional key under which to filter all the entries
     */
    public async getEntries(
        userScope: string,
        key?: string
        ): Promise<{ [key: string] : any; }> {

        return this.beginRequest<{ [key: string] : any; }>({
            apiVersion: "4.1-preview.1",
            routeTemplate: "_apis/Settings/Entries/{userScope}/{*key}",
            routeValues: {
                userScope: userScope,
                key: key
            }
        });
    }

    /**
     * Remove the entry or entries under the specified path
     * 
     * @param userScope - User-Scope at which to remove the value. Should be "me" for the current user or "host" for all users.
     * @param key - Root key of the entry or entries to remove
     */
    public async removeEntries(
        userScope: string,
        key: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "4.1-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/Settings/Entries/{userScope}/{*key}",
            routeValues: {
                userScope: userScope,
                key: key
            }
        });
    }

    /**
     * Set the specified setting entry values for the given user/all-users scope
     * 
     * @param entries - The entries to set
     * @param userScope - User-Scope at which to set the values. Should be "me" for the current user or "host" for all users.
     */
    public async setEntries(
        entries: { [key: string] : any; },
        userScope: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "4.1-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/Settings/Entries/{userScope}/{*key}",
            routeValues: {
                userScope: userScope
            },
            body: entries
        });
    }

    /**
     * Get all setting entries for the given named scope
     * 
     * @param userScope - User-Scope at which to get the value. Should be "me" for the current user or "host" for all users.
     * @param scopeName - Scope at which to get the setting for (e.g. "project" or "team")
     * @param scopeValue - Value of the scope (e.g. the project or team id)
     * @param key - Optional key under which to filter all the entries
     */
    public async getEntriesForScope(
        userScope: string,
        scopeName: string,
        scopeValue: string,
        key?: string
        ): Promise<{ [key: string] : any; }> {

        return this.beginRequest<{ [key: string] : any; }>({
            apiVersion: "4.1-preview.1",
            routeTemplate: "_apis/Settings/{scopeName}/{scopeValue}/Entries/{userScope}/{*key}",
            routeValues: {
                userScope: userScope,
                scopeName: scopeName,
                scopeValue: scopeValue,
                key: key
            }
        });
    }

    /**
     * Remove the entry or entries under the specified path
     * 
     * @param userScope - User-Scope at which to remove the value. Should be "me" for the current user or "host" for all users.
     * @param scopeName - Scope at which to get the setting for (e.g. "project" or "team")
     * @param scopeValue - Value of the scope (e.g. the project or team id)
     * @param key - Root key of the entry or entries to remove
     */
    public async removeEntriesForScope(
        userScope: string,
        scopeName: string,
        scopeValue: string,
        key: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "4.1-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/Settings/{scopeName}/{scopeValue}/Entries/{userScope}/{*key}",
            routeValues: {
                userScope: userScope,
                scopeName: scopeName,
                scopeValue: scopeValue,
                key: key
            }
        });
    }

    /**
     * Set the specified entries for the given named scope
     * 
     * @param entries - The entries to set
     * @param userScope - User-Scope at which to set the values. Should be "me" for the current user or "host" for all users.
     * @param scopeName - Scope at which to set the settings on (e.g. "project" or "team")
     * @param scopeValue - Value of the scope (e.g. the project or team id)
     */
    public async setEntriesForScope(
        entries: { [key: string] : any; },
        userScope: string,
        scopeName: string,
        scopeValue: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "4.1-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/Settings/{scopeName}/{scopeValue}/Entries/{userScope}/{*key}",
            routeValues: {
                userScope: userScope,
                scopeName: scopeName,
                scopeValue: scopeValue
            },
            body: entries
        });
    }

}

export const SettingsClientName = "ISettingsRestClient";

export function getSettingsClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ISettingsRestClient {
    return pageContext.getRestClient<ISettingsRestClient>(SettingsClientName, options);
}

RestClients.add(SettingsClientName, { 
    factory: SettingsRestClient
});
